import { useTranslation } from "react-i18next";
/** The current UI language; the calling component re-renders when it changes. */
export function useLanguage() {
    return useTranslation().i18n.language;
}
//# sourceMappingURL=useLanguage.js.map